module.exports = __webpack_public_path__ + "media/images/accountSection__settings-6a78cee3d263f73624c02908659a4a14.png";